import {
  BrowserRouter,
  // HashRouter,
  Route,
  Routes,
} from 'react-router-dom'
import { Provider as MobxProvider } from 'mobx-react'
import Home from '@/pages/Home'
import Page404 from '@/pages/404'

import RuralBusiness from '@/components/Content/RuralBusiness'
import { RootStore } from '@/store'

// eslint-disable-next-line n/prefer-global/process
const isDev = process.env.NODE_ENV === 'development'

function App() {
  return (
    <div>
      <MobxProvider {...RootStore}>
        <BrowserRouter basename={isDev ? '/' : '/nddt/portal'} >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/404" element={<Page404 />} />
            <Route path="/ruralBusiness" element={<RuralBusiness />} />
          </Routes>
        </BrowserRouter>
      </MobxProvider>
    </div>
  )
}

export default App
